import { biToast } from '@pulsepointinc/bi-components';
import { useQuery } from '@tanstack/react-query';
import {
  fetchFilterConfig,
  type GetFilterConfigQueryResponse,
  type GetFilterConfigRequest,
} from '../../lib/api/filterConfig';

export function useGetFilterConfigQuery(
  params: GetFilterConfigRequest,
  options?: { enabled?: boolean; staleTime?: number },
) {
  return useQuery<GetFilterConfigQueryResponse>({
    queryKey: ['filterConfig', params],
    queryFn: () => fetchFilterConfig(params),
    meta: {
      onError: () => {
        biToast.error('Failed to Load', 'Unable to load filter configuration. Please refresh the page.');
      },
    },
    enabled: options?.enabled ?? true,
    ...(options?.staleTime ? { staleTime: options.staleTime } : {}),
  });
}
